module.exports = __webpack_public_path__ + "static/img/bg_top.40a68e2f.png";